import { render, staticRenderFns } from "./TripInfo.vue?vue&type=template&id=05c90d18&scoped=true"
import script from "./TripInfo.vue?vue&type=script&lang=js"
export * from "./TripInfo.vue?vue&type=script&lang=js"
import style0 from "./TripInfo.vue?vue&type=style&index=0&id=05c90d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c90d18",
  null
  
)

export default component.exports